import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { endpoints } from 'environments/endpoints';
import { UserUserProfile } from '../../models/actors-users/userUserProfile.modele';
import { HttpHeadersUtil } from 'app/shared/utils/http-headers.util';

@Injectable({
  providedIn: 'root'
})
export class UserUserProfileService {
  private baseRoute = environment.GATEWAY_API + endpoints.userUserProfile.baseRoute;
  private subRoutes = endpoints.userUserProfile.subRoutes;

  constructor(private _httpClient: HttpClient) {}

  update(userUserProfile: UserUserProfile): Observable<UserUserProfile> {
    return this._httpClient.put<UserUserProfile>(
      `${this.baseRoute}${this.subRoutes.update}`,
      userUserProfile,
      HttpHeadersUtil.prepareDefaultHeaders()
    );
  }

  getAll(): Observable<UserUserProfile[]> {
    return this._httpClient.get<UserUserProfile[]>(
      `${this.baseRoute}${this.subRoutes.getAll}`,
      HttpHeadersUtil.prepareDefaultHeaders()
    );
  }

  getAllByUser(userId: string, isTera?: boolean, isSica?: boolean): Observable<UserUserProfile[]> {
    return this._httpClient.get<UserUserProfile[]>(
      `${this.baseRoute}${this.subRoutes.getAllByUser + userId}${this.buildPlatformQuery(isTera, isSica)}`,
      HttpHeadersUtil.prepareDefaultHeaders()
    );
  }

  add(userUserProfile: UserUserProfile): Observable<UserUserProfile> {
    return this._httpClient.post<UserUserProfile>(
      `${this.baseRoute}${this.subRoutes.add}`,
      userUserProfile,
      HttpHeadersUtil.prepareDefaultHeaders()
    );
  }

  delete(userUserProfileId: string): Observable<void> {
    return this._httpClient.delete<void>(
      `${this.baseRoute}${this.subRoutes.delete + userUserProfileId}`,
      HttpHeadersUtil.prepareDefaultHeaders()
    );
  }

  updateUserProfiles(
    userUserProfiles: UserUserProfile[],
    userId: string,
    isTera?: boolean,
    isSica?: boolean
  ): Observable<void> {
    return this._httpClient.post<void>(
      `${this.baseRoute}${this.subRoutes.removeUserProfiles}/${userId}${this.buildPlatformQuery(isTera, isSica)}`,
      userUserProfiles,
      HttpHeadersUtil.prepareDefaultHeaders()
    );
  }

  private buildPlatformQuery(isTera?: boolean, isSica?: boolean): string {
    const params = [];
    if (isTera !== undefined && isTera !== null) {
      params.push(`isTera=${isTera}`);
    }
    if (isSica !== undefined && isSica !== null) {
      params.push(`isSica=${isSica}`);
    }
    return params.length ? `?${params.join('&')}` : '';
  }
}
